import { Card, Intent } from '@blueprintjs/core';
import { SearchResultStatus } from '@retro-ui/shared';

import TagSelect from '@f/components/shared/select/TagSelect';

import cls from './Filter.module.css';

interface StatusFilterCardProps {
  value: SearchResultStatus[];
  onChange: (value: SearchResultStatus[]) => void;
}
export function StatusFilterCard(props: StatusFilterCardProps) {
  const { value, onChange } = props;

  const changeStatus = items => {
    onChange(items.map(({ status }) => status));
  };

  return (
    <Card>
      <small className={cls.label}>STATUS</small>
      <div>
        <TagSelect
          enableSelectAll
          enableSelectNone
          items={[
            { status: SearchResultStatus.COMPLETED, label: 'Completed' },
            { status: SearchResultStatus.FAILED, label: 'Failed' },
            { status: SearchResultStatus.RUNNING, label: 'Running' },
          ]}
          selectedItemIds={value}
          idField="status"
          groups={[
            {
              id: SearchResultStatus.COMPLETED,
              tagProps: {
                intent: Intent.SUCCESS,
              },
            },
            {
              id: SearchResultStatus.FAILED,
              tagProps: {
                intent: Intent.DANGER,
              },
            },
            {
              id: SearchResultStatus.RUNNING,
              tagProps: {
                intent: Intent.WARNING,
              },
            },
          ]}
          groupBy="status"
          labelField="label"
          placeholder="Statuses..."
          onChange={changeStatus}
        />
      </div>
    </Card>
  );
}
